<template>
    <div class="deground">
        <headerpage :status="3"></headerpage>
        <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="hetext">首页>园区企业>详情</div>

            <!--详情内容-->

            <div style="height: 30px;"></div>
        </div>
    </div>
</template>

<script>
import headerpage from '../../components/header/header.vue';
export default {
    components: { headerpage },
    data() {
        return {
            detail: '',
            showall: false,
            tppindex: 1,
            shareholder: [],
            people_list: [],
            change_record: [],
            com: [{
                totalnum: 0,
                currentPage: 1,
                pagesize: 15,
                type: 0
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 1
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 2
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 3
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 4
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 5
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 6
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 7
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 8
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 9
            }, {
                totalnum: 0,
                currentPage: 1,
                pagesize: 8,
                type: 10
            }],
            people_list: [],  //主要人员  1
            shareholder: [],  //股东信息  2
            change_record: [],//变更记录  3
            qualification_list: [],// 资质证书 4
            seniority_list: [],// 资质资格列表 5
            brand_list: [],// 商标信息 6
            patent_list: [],//专利信息 7
            softright_list: [],// 软件著作权 8
            copyright_list: [],// 作品著作权 9
            webregister_list: [],//网站备案列表 10
        }
    },
    methods: {
        handleCurrentChange: function (currentPage, index) {
            this.com[index].currentPage = currentPage;
            // console.log(this.currentPage)  //点击第几页
            // this.rightlist = [];
            switch (index) {
                case 0:
                    this.getnewlist();
                    break;
                case 1:
                    this.getpeoplelist();
                    break;
                case 2:
                    this.getshare();
                    break;
                case 3:
                    this.getchange();
                    break;
                case 4:
                    this.getqua();
                    break;
                case 5:
                    this.getseniority();
                    break;
                case 6:
                    this.getbrand();
                    break;
                case 7:
                    this.getpatent();
                    break;
                case 8:
                    this.getsoftright();
                    break;
                case 9:
                    this.getcopyright();
                    break;
                case 10:
                    this.getweb();
                    break;

            }

        },
        getqua() {
            //enterprise_support
            var api = this.$api.api.index.qualification_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[4].currentPage,
                    page_size: this.com[4].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);
                    if (response.data.length) {
                        for (let i in response.data) {
                            if (response.data[i].href) {
                                if (response.data[i].href.indexOf("http") == -1) {
                                    response.data[i].href = 'http://' + response.data[i].href;
                                }
                            }
                        }
                    }
                    this.qualification_list = response.data;
                    this.com[4].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getnewlist() {
            //enterprise_support
            var api = this.$api.api.index.enterprise_support;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[0].currentPage,
                    page_size: this.com[0].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);

                    response.data.policy_support.forEach(item => {
                        item['showz'] = false;
                        // !item.support &&
                        if (!item.province_support && !item.city_support && !item.area_support) {
                            item['showz'] = true;
                        }
                    });
                    this.supporttotal_money = response.data.total_money;
                    this.newlist = response.data.policy_support;
                    this.com[0].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getpeoplelist() {
            //enterprise_support
            var api = this.$api.api.index.majorpeople_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[1].currentPage,
                    page_size: this.com[1].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);

                    this.people_list = response.data;
                    this.com[1].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getshare() {
            //enterprise_support
            var api = this.$api.api.index.shareholder_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[2].currentPage,
                    page_size: this.com[2].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);

                    this.shareholder = response.data;
                    this.com[2].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getchange() {
            //enterprise_support
            var api = this.$api.api.index.change_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[3].currentPage,
                    page_size: this.com[3].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);

                    this.change_record = response.data;
                    this.com[3].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },




        getdetail() {
            var api = this.$api.api.index.enterprise_detail;
            const loading = this.$loading({
                lock: true,
                text: '正在加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0)'
            });
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    id: this.id
                },
                (response) => {
                    loading.close();
                    console.log("response", response);
                    if (response.data.policy_support) {
                        if (response.data.policy_support.length) {
                            for (let i in response.data.policy_support) {
                                if (response.data.policy_support[i].href) {
                                    if (response.data.policy_support[i].href.indexOf("http") == -1) {
                                        response.data.policy_support[i].href = 'http://' + response.data.policy_support[i].href;
                                    }
                                }
                            }
                        }
                    }
                    if (response.data.brand) {
                        if (response.data.brand.length) {
                            for (let i in response.data.brand) {
                                if (response.data.brand[i].href) {
                                    if (response.data.brand[i].href.indexOf("http") == -1) {
                                        response.data.brand[i].href = 'http://' + response.data.brand[i].href;
                                    }
                                }
                            }
                        }
                    }

                    if (response.data.copyright) {
                        if (response.data.copyright.length) {
                            for (let i in response.data.copyright) {
                                if (response.data.copyright[i].href) {
                                    if (response.data.copyright[i].href.indexOf("http") == -1) {
                                        response.data.copyright[i].href = 'http://' + response.data.copyright[i].href;
                                    }
                                }
                            }
                        }
                    }

                    if (response.data.patent) {
                        if (response.data.patent.length) {
                            for (let i in response.data.patent) {
                                if (response.data.patent[i].href) {
                                    if (response.data.patent[i].href.indexOf("http") == -1) {
                                        response.data.patent[i].href = 'http://' + response.data.patent[i].href;
                                    }
                                }
                            }
                        }
                    }

                    if (response.data.qualification) {
                        if (response.data.qualification.length) {
                            for (let i in response.data.qualification) {
                                if (response.data.qualification[i].href) {
                                    if (response.data.qualification[i].href.indexOf("http") == -1) {
                                        response.data.qualification[i].href = 'http://' + response.data.qualification[i].href;
                                    }
                                }
                            }
                        }
                    }


                    this.detail = response.data;
                },
                (error) => {
                    loading.close();
                    console.log(error);
                }
            );
        },
        handleSizeChange(size) {
            // this.pagesize = size;
            // console.log(size); //每页下拉显示数据
        },
        getpatent() {
            var api = this.$api.api.index.patent_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[7].currentPage,
                    page_size: this.com[7].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);
                    if (response.data.length) {
                        for (let i in response.data) {
                            if (response.data[i].href) {
                                if (response.data[i].href.indexOf("http") == -1) {
                                    response.data[i].href = 'http://' + response.data[i].href;
                                }
                            }
                        }
                    }
                    this.patent_list = response.data;
                    this.com[7].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getbrand() {
            var api = this.$api.api.index.brand_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[6].currentPage,
                    page_size: this.com[6].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);
                    if (response.data.length) {
                        for (let i in response.data) {
                            if (response.data[i].href) {
                                if (response.data[i].href.indexOf("http") == -1) {
                                    response.data[i].href = 'http://' + response.data[i].href;
                                }
                            }
                        }
                    }

                    this.brand_list = response.data;
                    this.com[6].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getcopyright() {
            var api = this.$api.api.index.copyright_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[9].currentPage,
                    page_size: this.com[9].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);
                    if (response.data.length) {
                        for (let i in response.data) {
                            if (response.data[i].href) {
                                if (response.data[i].href.indexOf("http") == -1) {
                                    response.data[i].href = 'http://' + response.data[i].href;
                                }
                            }
                        }
                    }
                    this.copyright_list = response.data;
                    this.com[9].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getsoftright() {
            var api = this.$api.api.index.softright_list;
            this.$https.post(
                {
                    api: api,
                    type: "formData",
                },
                {
                    page: this.com[8].currentPage,
                    page_size: this.com[8].pagesize,
                    id: this.id
                },
                (response) => {
                    console.log("response", response);

                    this.softright_list = response.data;
                    this.com[8].totalnum = response.count;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
    },
    created: function () {

        this.id = this.$route.query.id;
        this.getdetail();
        // this.getlike();
        // this.getadv();
        this.getbrand()
        this.getqua()
        this.getnewlist();
        this.getpatent();//专利信息
        this.getpeoplelist();//主要人员
        this.getshare();//股东信息
        this.getchange();//变更记录
        this.getsoftright();//软件著作权
        this.getcopyright();//作品著作权

    }
}
</script>
<style scoped>
.hetext {
    font-size: 15px;
    color: #bdbdbd;
    padding: 16px 0;
    cursor: pointer;
}

input {
    height: 30px !important;
    line-height: 30px !important;
}

.content {
    width: 1350px;
    margin: 8px auto;
}

.cleft {
    width: 100%;
    /* width: 1044px; */
    /* background: #fff; */
}

.cright {
    width: 286px;
    /* background: #fff; */
    position: sticky;
    /* top: 166px; */
    top: 20px;
}

.sty {
    color: #ffffff;
    background: #0070c0;
}

.box5 {
    width: 100%;
    display: flex;
    min-height: 50px;
    border-bottom: 1px solid #f1f1f1;
}

.box5_text1 {
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    border-left: 1px solid #f1f1f1;
    /* padding: 0 10px; */

    color: #000;
}

.box5_text2 {
    width: 18%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    color: #000;
}

.box5_text3 {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #f1f1f1;
    color: #000;
}

.box2_cc {
    color: #ffffff;
    background-color: #F0F5FF;
}

.company_logo {
    margin-right: 20px;
    width: 96px;
    height: 96px;
    border-radius: 9px;
    text-align: center;
    /* line-height: 80px; */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 29px;
    color: #ffffff;
}

.company_logo img {
    width: 80px;
    height: 80px;
}

.comright {
    width: 90%;
    min-height: 96px;
}

.comname {
    color: #292a2d;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
    padding-right: 16px;
}

.tagone {
    padding: 0 5px;
    margin: 0 8px 8px 0;
    font-size: 12px;
    font-weight: 400;
    background: #fff6ee;
    color: #ffa408;
    line-height: 19px;
}

.lefttag {
    color: #9a9a9a;
    margin-right: 8px;
    font-size: 14px;
    font-weight: 400;
    /* width: 20%; */
}

.righttag {
    color: #292a2d;
    font-size: 14px;
    font-weight: 400;
    width: 83%
}

.righttag2 {
    display: inline-block;
    cursor: pointer;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #292a2d;
    font-weight: 400;
    margin-left: 8px;
    line-height: 20px;
    width: 90%;
}

.hideblock {
    white-space: nowrap;
}

.toptitle {
    margin-bottom: 15px;
    margin-top: 26px;
}

.topleft {
    font-size: 20px;
    color: #292a2d;
    letter-spacing: 0;
    line-height: 1;
    font-weight: 700;
}

.topright {
    color: #666;
    letter-spacing: 0;
    font-weight: 400;
}

.rione {
    font-size: 20px;
    color: #292a2d;
    letter-spacing: 0;
    font-weight: 500;
}

.rinum {
    font-size: 20px;
    font-weight: 700;
    color: #0070c0;
    margin-left: 5px;
}

#table,
#table td,
#table th {
    border: 1px solid #dae4ec
}

.label,
.value {
    height: 50px;
    padding-left: 16px;
    font-size: 14px;
}

.label {
    width: 232px;
    font-weight: 500;
    background: #f0f5ff;
}

.value {
    width: 735px;
    font-weight: 400;
    background: #fff;
}

.samecom {
    height: 50px;
    line-height: 50px;
    width: 100%;
    color: #292a2d;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #eff2f6;
    text-align: center;
}

.likeone {
    height: auto;
    padding: 12px 16px;
    border-bottom: 1px solid #eff2f6;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    /* align-content: center; */
    align-items: flex-start;
}

.likeone:hover {
    /* background: #f6f7fb;
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 2px;
  z-index: 9;
  position: relative; */
}

.oneleft {
    width: 44px;
    height: 44px;
}

.oneleft img {
    width: 44px;
    max-height: 44px;
}

.oneright {
    padding-left: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
}

.oneright p {
    font-size: 14px;
    color: #292a2d;
    font-weight: 400;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}

.oneright span {
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    background: #36a6f7;
    border-radius: 2px;
}

.box1_header {
    display: flex;
    height: 55px;
    padding: 0 15px;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.box1_header_text {
    font-size: 20px;
    color: #111111;
    font-weight: 600;
    margin-left: 10px;
}

.box1_header_shu {
    width: 4px;
    height: 21px;
    background-color: #0070c0;
}

.likeone1 {
    height: auto;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 25px;
}

.likeone1:hover {
    /* background: #f6f7fb;
  box-shadow: 0 6px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 2px;
  z-index: 9;
  position: relative; */
}

.likeone1:last-child {
    margin-bottom: 0px;
}

.oneleft1 {
    width: 99px;
    height: 99px;
}

.oneleft1 img {
    width: 99px;
    height: 99px;
    border-radius: 10px;
}

.oneright1 {
    margin-top: 10px;
    width: 77%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
}

.oneright1 p {
    font-size: 14px;
    color: #292a2d;
    font-weight: 400;
    padding-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 214px;
}

.oneright1 span {
    display: inline-block;
    padding: 2px 8px;
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    background: #36a6f7;
    border-radius: 2px;
}


td,
th {
    padding: 0;
}

.pure-table {
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    border: 1px solid #cbcbcb;
    width: 100%;
}

.pure-table caption {
    color: #000;
    /* font: italic 85%/1 arial,sans-serif; */
    padding: 1em 0;
    text-align: center;
}

.pure-table td,
.pure-table th {
    border-left: 1px solid #cbcbcb;
    border-width: 0 0 0 1px;
    font-size: inherit;
    margin: 0;
    overflow: visible;
    padding: 1em 0.5em;
    vertical-align: middle;
}

.pure-table thead {
    background-color: #e0e0e0;
    color: #000;
    text-align: left;
    vertical-align: bottom;
}

.pure-table td {
    background-color: transparent;
}

.pure-table-bordered td {
    border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody>tr:last-child>td {
    border-bottom-width: 0;
}

.response {
    width: 100%;
}

.fivewidth {
    width: 50%;
}

.newmar {
    margin-bottom: 12px;
}

.new_bot {
    margin: 0;
    line-height: 80px;
}

.bott {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.box {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.box_cent {
    font-size: 14px;
    color: #3277f1;
    padding: 3px 5px;
    background-color: #dff1ff;
    border-radius: 4px;
}

.box_cent {
    margin-right: 20px;
}

.box_cent:last-child {
    margin-right: 0;
}

.boxt {
    display: flex;
    width: 100%;
    height: 55px;
    background-color: #f2f6ff;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 30px;
    border-radius: 10px 10px 0 0;
}

.boxt_cent {
    width: 25%;
    text-align: center;
    font-size: 20px;
    color: #000000;
    font-weight: 600;
    height: 100%;
    line-height: 55px;
    overflow: hidden;
    cursor: pointer;
    border: solid 1px #f2f6ff;
}

.boxt_cent:first-child {
    border-radius: 10px 0 0 0;
}

.boxt_cent:last-child {
    border-radius: 0 10px 0 0;
}

.boxtsty {
    background-color: #ffffff;
    border: solid 1px #dae0ee;
    color: #386af6;
}

.box6 {
    background-color: #ffffff;
    border-radius: 10px;
    margin-top: 15px;
    padding-bottom: 30px;
    /* margin-bottom: 30px; */
}

.box6_top {
    padding: 20px 35px;
    border-bottom: 3px solid #f6f8f7;
    display: flex;
}

.box6_top_cent {
    width: 25%;
    height: 58px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
    cursor: pointer;
}

.box6_top_sty {
    background-color: #f2f6ff;
    color: #386af6;
}

.box6_cent {
    padding: 0 35px;
}
</style>




// WEBPACK FOOTER //
// enterprisedetail.vue?273e0f5e